import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ObjectiveListComponent } from './objective-list/objective-list.component'

export const objectiveRoutes: Route[] = [
  {
    path: 'objectives',
    component: ObjectiveListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'objectives/:id/edit',
    redirectTo: 'objectives/:id',
    pathMatch: 'full'
  },
  {
    path: 'objectives/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Objective',
        nameSingular: 'Objective',
        namePlural: 'Objectives',
        path: 'objectives',
        slug: 'taxonomies/objectives',
        title: 'Objectives'
      }),
      permission: 'readTaxonomies'
    }
  }
]
